import React from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const MenuItem = props => {
	const { icon, title, handleMenu, type, disable, subButton, subIcon } =
		props;
	const classes = useStyles();

	return (
		<Grid
			classes={{
				root: disable ? classes.btnDefaultDisable : classes.menuItem
			}}
			style={{ opacity: disable ? 0.3 : 1 }}
			onClick={() => handleMenu(type)}
		>
			<Grid classes={{ root: classes.iconMenu }}>
				<img src={icon} alt={icon} />
				{title}
			</Grid>
			<Grid style={{ display: "flex", alignItems: "center" }}>
				{subIcon && (
					<img
						src={subIcon}
						alt={"subIcon"}
						style={{ marginRight: 8 }}
					/>
				)}
				{subButton && subButton}
				{!subButton && (
					<img src={Images.icArrowForward} alt={"icArrowForward"} />
				)}
			</Grid>
		</Grid>
	);
};

export default MenuItem;
